import { styled, type SxProps } from '@mui/material';
import React from 'react';

import { Sign } from '../_assets/Sign.tsx';

const Root = styled('div')(() => ({}));

const Card = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light,
  borderRadius: '8px',
  padding: '20px 25px',
  position: 'relative',
}));

const Circle = styled('span')(({ theme }) => ({
  borderRadius: '9999999px',
  aspectRatio: '1 / 1',
  fontSize: '1.125rem',
  color: 'white',
  fontWeight: 700,
  backgroundColor: theme.palette.neutral.dark,
  display: 'inline-grid',
  height: '32px',
  lineHeight: 1,
  placeContent: 'center',
}));

const List = styled('ol')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  '& li': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  [theme.breakpoints.up('xl')]: {
    gap: theme.spacing(2),
  },
}));

export type RulesCardProps = {
  sx?: SxProps;
};

export const RulesCard: React.FC<RulesCardProps> = ({ sx }) => {
  return (
    <Root sx={sx}>
      <Sign
        sx={{
          width: 312,
          mb: -8,
          zIndex: -1,
          ml: { lg: 3 },
          mt: { md: -9 },
          display: { xs: 'none', md: 'inline-block' },
        }}
      />
      <Card>
        <div className="mb-6 typography-v1-h1 md:hidden">Gjeldvettreglene</div>

        <div className="typography-v1-body3">
          <List>
            <li>
              <Circle>1</Circle>
              Ikke ta opp mer lån, fiks gjelden du allerede har
            </li>
            <li>
              <Circle>2</Circle>
              Få full oversikt over gjelden og hvor mye du betaler i rente
            </li>
            <li>
              <Circle>3</Circle>
              <b>Sjekk jevnlig om du kan få lavere rente</b>
            </li>
            <li>
              <Circle>4</Circle>
              <b>Det er ingen skam å snu! Bytt bank dersom du kan få lavere rente</b>
            </li>
            <li>
              <Circle>5</Circle>
              <b>Prioriter dyre lån - betal ned lån med høyest rente først</b>
            </li>
            <li>
              <Circle>6</Circle>
              Ekstra innbetalinger korter ned løpetiden og totalkostanden
            </li>
            <li>
              <Circle>7</Circle>
              Betal kredittkortgjeld før den blir rentebærende, eller flytt den til et lån med
              lavere rente
            </li>
          </List>
        </div>
      </Card>
    </Root>
  );
};
